import { useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import { AppRoutes } from './app/router';
import { useAuth } from './app/stores/auth';
import { useOverlays } from './app/stores/overlays';
import { AuthModal } from './features/auth/AuthModal';

export function App() {
  const refresh = useAuth((s) => s.refresh);
  const authOpen = useOverlays((s) => s.stack.includes('auth'));

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return (
    <BrowserRouter>
      <AppRoutes />
      {authOpen && <AuthModal />}
    </BrowserRouter>
  );
}
